
import { useTranslation } from "react-i18next";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Control } from "react-hook-form";
import { SubscriptionFormValues } from "./SubscriptionFormSchema";
import { useCurrency } from "@/contexts/CurrencyContext";

interface SubscriptionPriceFieldProps {
  control: Control<SubscriptionFormValues>;
}

export function SubscriptionPriceField({ control }: SubscriptionPriceFieldProps) {
  const { t } = useTranslation(["subscriptions", "payments"]);
  const { currency } = useCurrency();

  return (
    <FormField
  control={control}
  name="price"
  render={({ field }) => (
    <FormItem>
      <FormLabel>{t('price', { ns: 'subscriptions' })}</FormLabel>
      <FormControl>
        <div className="relative">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 pr-1 w-8 text-sm text-muted-foreground">
            {currency === "EUR" ? "€" : currency}
          </span>
          <input
            {...field}
            className="flex h-10 w-full rounded-md border border-input bg-background pl-14 pr-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
          />
        </div>
      </FormControl>
      <FormMessage />
    </FormItem>
      )}
    />
  );
}
